var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49716 4.6886H3.76002C3.05302 4.6886 2.37499 4.96945 1.87507 5.46937C1.37515 5.96928 1.0943 6.64732 1.0943 7.35431V16.8343C1.0943 17.5413 1.37515 18.2193 1.87507 18.7192C2.37499 19.2192 3.05302 19.5 3.76002 19.5H13.24C13.947 19.5 14.6251 19.2192 15.125 18.7192C15.6249 18.2193 15.9057 17.5413 15.9057 16.8343V7.35431C15.9057 6.64732 15.6249 5.96928 15.125 5.46937C14.6251 4.96945 13.947 4.6886 13.24 4.6886H12.4943V5.67431C12.4943 5.7531 12.4788 5.83113 12.4486 5.90392C12.4185 5.97672 12.3743 6.04286 12.3186 6.09857C12.2629 6.15429 12.1967 6.19849 12.1239 6.22864C12.0511 6.25879 11.9731 6.27431 11.8943 6.27431H5.07145C4.99194 6.27545 4.91299 6.26077 4.8392 6.23112C4.76542 6.20148 4.69826 6.15746 4.64163 6.10163C4.585 6.04581 4.54004 5.97928 4.50935 5.90592C4.47867 5.83256 4.46287 5.75383 4.46288 5.67431L4.49716 4.6886Z",
    stroke: "#362F41",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1743 14.0228H5.82574",
    stroke: "#AAB2BD",
    strokeOpacity: 0.956863,
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1743 10.5H5.82574",
    stroke: "#AAB2BD",
    strokeOpacity: 0.956863,
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49717 5.67428V4.49999C4.49254 4.42005 4.50374 4.33997 4.53011 4.26436C4.55649 4.18875 4.59753 4.11908 4.65088 4.05936C4.70423 3.99964 4.76884 3.95104 4.84101 3.91633C4.91319 3.88163 4.9915 3.86152 5.07146 3.85714H6.58861C6.57553 3.72317 6.57553 3.58825 6.58861 3.45428C6.58861 2.93597 6.7945 2.4389 7.161 2.0724C7.5275 1.7059 8.02458 1.5 8.54289 1.5C9.0612 1.5 9.55828 1.7059 9.92478 2.0724C10.2913 2.4389 10.4972 2.93597 10.4972 3.45428C10.5103 3.58825 10.5103 3.72317 10.4972 3.85714H11.9286C12.0081 3.85713 12.0869 3.87293 12.1602 3.90362C12.2336 3.9343 12.3001 3.97927 12.3559 4.03589C12.4118 4.09252 12.4558 4.15968 12.4854 4.23347C12.5151 4.30725 12.5297 4.3862 12.5286 4.46571V5.67428C12.5286 5.75307 12.5131 5.83109 12.4829 5.90389C12.4528 5.97668 12.4086 6.04283 12.3529 6.09854C12.2972 6.15426 12.231 6.19845 12.1582 6.22861C12.0854 6.25876 12.0074 6.27428 11.9286 6.27428H5.07146C4.91683 6.26764 4.77074 6.20151 4.66372 6.0897C4.5567 5.97789 4.49703 5.82905 4.49717 5.67428Z",
    stroke: "#362F41",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.b6b4f0099a789878bc422dda90958939.svg";
export { ForwardRef as ReactComponent };